/**
 * Created by lihanying on 2017/7/17.
 */
import React from 'react'
import { Table, Button, Message } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import './style.css'
import ModalAdd from './modalAdd'
import {
  fetchProfessionList,
  addProfession,
  modifyProfession,
  removeProfession,
} from '../../../api/clubProfession'

export default class extends React.Component {
  state = {
    visible: false,
    selectData: {},
  }

  handleOk = () => {
    // this.setState({ visible: false })
    // this.props.fetchAddFirmType({
    //   type_name: this.state.type_name,
    //   type_id: this.state.type_id,
    // })

    const { modalType } = this.state
    if (modalType == 'new') {
      addProfession({
        clubId: sessionStorage.getItem('club_id'),
        name: this.state.type_name,
        clz: -1,
      })
        .then((res) => {
          if (res.status != 1) {
            Message.error(res.detail)
            return Promise.reject()
          }
          this.setState({ visible: false })
        })
        .then(() => {
          Message.success('操作成功')
          this.props.getProfessionList()
        })
    }
    if (modalType == 'edit') {
      modifyProfession({
        id: this.state.selectData.id,
        clubId: sessionStorage.getItem('club_id'),
        name: this.state.type_name,
        clz: -1,
      })
        .then((res) => {
          if (res.status != 1) {
            Message.error(res.detail)
            return Promise.reject()
          }
          this.setState({ visible: false })
        })
        .then(() => {
          Message.success('操作成功')
          this.props.getProfessionList()
        })
    }
  }

  handleCancel = () => {
    this.setState({ visible: false })
  }

  handleInput = (e) => {
    this.setState({
      type_name: e.target.value,
    })
  }
  handleSelect = (value) => {
    this.setState({ type_id: value })
  }

  showModify = (record, type) => {
    this.setState({
      selectData: record,
      modalType: type,
      visible: true,
      type_name: record.name,
      type_id: record.clz,
    })
  }

  DeleteProfession = (id) => {
    removeProfession({
      id: id,
      clubId: sessionStorage.getItem('club_id'),
    })
      .then((res) => {
        if (res.status != 1) {
          Message.error(res.detail)
          return
        }
        Message.success('删除成功')
      })
      .then(() => {
        this.props.getProfessionList()
      })
  }

  render() {
    const { list, totalType } = this.props
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '分组名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div style={{ color: '#108EE9', cursor: 'default' }}>
              <Button
                type="primary"
                style={{ marginRight: '20px' }}
                onClick={() => {
                  this.showModify(record, 'edit')
                }}
              >
                修改
              </Button>
              <Popconfirm
                title={`你确认要删除${record.name}分组吗?`}
                okText="确认"
                cancelText="取消"
                onConfirm={() => this.DeleteProfession(record.id)}
              >
                <Button type="primary" danger>
                  删除
                </Button>
              </Popconfirm>
            </div>
          )
        },
      },
    ]

    return (
      <div className="profession">
        <div className="profession-edit-btn">
          <Button type="primary" onClick={() => this.showModify({}, 'new')}>
            添加业务分组
          </Button>
        </div>
        <Table rowKey="id" columns={columns} dataSource={list} bordered />

        {this.state.visible && (
          <ModalAdd
            {...this.state}
            totalType={totalType}
            selectData={this.state.selectData}
            modalType={this.state.modalType}
            handleOk={this.handleOk}
            handleCancel={this.handleCancel}
            handleInput={this.handleInput}
            handleSelect={this.handleSelect}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubProfession/component/professionType.js